<template>
  <div class="rss-view">
    <template v-if="loading">
      <loader width="48px" height="48px" stroke="#4C4C4C"/>
    </template>
    <template v-else>
      
      <inner-navigation>
        <router-link to="/rss/audi">Новости Audi</router-link>
        <router-link to="/rss/service">Новости Сервис</router-link>
      </inner-navigation>

      <component v-if="categories.length" :is="tableType"/>

      <!-- <paginator :model="meta.list_data"/> -->
    </template>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import TableElement from '@/components/common/TableElement';

import * as tables from './tables';

export default {
  name: 'rss-view',

  components: {
    TableElement,
    ...tables,
  },

  computed: {
    ...mapGetters({
      loading: 'config/loading',
      error: 'config/error',
      meta: 'config/meta',
      categories: 'rss/categories',
    }),

    // TODO: Переместить все config'и в config store

    tableType() {
      return this.$route.meta.tableType;
    },
  },

  methods: {
    ...mapActions({
      getConfig: 'rss/getConfig',
    }),
  },

  async beforeMount() {
    await this.getConfig();
  },
};
</script>

<style lang="scss" scoped>
.rss-view {
  display: flex;
  flex-direction: column;
  position: relative;
  min-height: 100%;
}
</style>